import Vue from 'vue'
import Router from 'vue-router'
import shouye from '../components/shouye'
import discover from '../components/discover'
import sous from '../components/shouye/sous'
import activity from '../components/activity'
import sign from '../components/activity/sign'
import mine from '../components/mine'
import dingdan from '../components/mine/dingdan'
import shouzang from '../components/mine/shouzang'
import fenxiang from '../components/mine/fenxiang'
import bofang from '../components/mine/bofang'
import liuyan from '../components/mine/liuyan'
import xingxi from '../components/mine/xingxi'
import vip from '../components/mine/vip'
import xiaoxi from '../components/mine/xiaoxi'
import discont from '../components/discover/discont'
import mmm from '../components/discover/mmm'
import anchor from '../components/shouye/anchor'
import pay from '../components/discover/pay'
import cntxx from '../components/activity/cntxx'
import tixian from '../components/mine/tixian'
import card from '../components/mine/card'
import addcard from '../components/mine/addcard'
import playm from '../components/video/playm'
import disv from '../components/video/disv'
import dilie from '../components/video/dilie'
import video from '../components/video/video'
Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'shouye/:id',
    component: shouye
  },
  {
    path: '/shouye/anchor/:id',
    name: 'anchor',
    component: anchor
  }, 
    {
    path: '/video/playm/:id',
    name: 'playm',
    component: playm
  },
  {
    path: '/video/disv/:id',
    name: 'disv',
    component: disv
  },
  {
    path: '/video/dilie/:id',
    name: 'dilie',
    component: dilie
  },
  {
    path: '/video/video',
    name: 'video',
    component: video
  },
  {
    path: '/discover/:id',
    name: 'discover',
    component: discover
  },
   {
    path: '/shouye/sous',
    name: 'sous',
    component: sous
  },
  {
    // 传参配置id
    path: '/discover/discont/:id',
    name: 'discont',
    component: discont
  },
  {
    path: '/discover/discont/mmm/:id',
    name: 'mmm',
    component: mmm
  },
  {
    path: '/discover/pay/:id',
    name: 'pay',
    component: pay
  },
  {
    path: '/activity/cntxx/:id',
    name: 'cntxx',
    component: cntxx
  },
  {
    path: '/activity/sign',
    name: 'sign',
    component: sign
  },
  {
    path: '/activity',
    name: 'activity',
    component: activity
  },
  {
    path: '/mine',
    name: 'mine',
    component: mine
    
  },
  {
    path:'/mine/dingdan',
    name: 'dingdan',
    component:dingdan
  },
  {
    path:'/mine/card',
    name: 'card',
    component:card
  },
  {
    path:'/mine/addcard',
    name: 'addcard',
    component:addcard
  },
   {
    path:'/mine/tixian',
    name: 'tixian',
    component:tixian
  },
  {
    path:'/mine/shouzang',
    name: 'shouzang',
    component:shouzang
  },
  {
    path:'/mine/fenxiang',
    name: 'fenxiang',
    component:fenxiang
  },
  {
    path:'/mine/bofang',
    name: 'bofang',
    component:bofang
  },
  {
    path:'/mine/xingxi',
    name: 'xingxi',
    component:xingxi
  },
  {
    path:'/mine/vip',
    name: 'vip',
    component:vip
  },
  {
    path:'/mine/xiaoxi',
    name: 'xiaoxi',
    component:xiaoxi
  },
  {
    path:'/mine/liuyan',
    name: 'liuyan',
    component:liuyan
  }],
   mode: 'history',
})



// WEBPACK FOOTER //
// ./src/router/index.js